//===============================================================/
// Utils
//===============================================================/

if (document.querySelector('.js-choices-selector')) {
  import('./js/utils/choices-selector')
}

if (document.querySelector('.js-form-filter')) {
  import('./js/utils/form-filter')
}

if (document.querySelector('.js-team-members') || document.querySelector('.js-team-member-link')) {
  import('./js/utils/teamMemberModal')
}


//===============================================================/
// Components
//===============================================================/

if (document.querySelector('.js-select-navigator')) {
  import('./js/components/selectNavigator')
}

if (document.querySelector('.js-table')) {
  import('./js/components/gridjsTable')
}

if (document.querySelector('.js-chart')) {
  import('./js/components/highchartChart')
}

if (document.querySelector('.js-academy-search')) {
  import('./js/components/academySearch')
}

if (document.querySelector('.js-academy-region-map')) {
  import('./js/components/regionMap')
}

if (document.querySelector('.js-accordion')) {
  import('./js/components/accordion')
}

if (document.querySelector('.js-share-list')) {
  import('./js/components/shareList')
}

if (document.querySelector('.js-region-carousel')) {
  import('./js/components/regionCarousel')
}

if (document.querySelector('.js-sdotsform-link')) {
  import('./js/components/userformModal')
}

if (document.querySelector('.js-inline-userform')) {
  import('./js/components/userformInline')
}

if (document.querySelector('.js-inline-customform')) {
  import('./js/components/customformInline')
}

if (document.querySelector('.js-iframe-video-wrapper')) {
  import('./js/components/iframeVideo')
}

if (document.querySelector('.js-dual-link-hover-wrapper')) {
  import('./js/components/dualLinkHover')
}

if (document.querySelector('.js-upcoming-webinar-carousel-wrapper')) {
  import('./js/components/upcomingWebinars')
}

if (document.querySelector('.js-map-container')) {
  import('./js/components/googleMap')
}

if (document.querySelector('.js-resource-filters')) {
  import('./js/components/resourceFilters')
}

if (document.querySelector('html.-show-back-to-top')) {
  import('./js/components/backToTop')
}

if (document.querySelector('.js-locale-select')) {
  import('./js/components/localeSelector')
}

//===============================================================/
// Blocks
//===============================================================/

// refactored to load dynamically

//===============================================================/
// Layout
//===============================================================/

if (document.querySelector('.js-header')) {
  import('./js/layout/header')
}

if (document.querySelector('.js-footer')) {
  import('./js/layout/footer')
}

//===============================================================/
// Pages
//===============================================================/

// refactored to load dynamically
